import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
} from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, db, isFirebaseConfigured, collections } from "./firebase.js";

export async function registerUser({ name = "", email = "", password, mobile = "" }) {
  if (!name.trim() || !email.trim() || !password || !mobile.trim()) throw new Error("Name, email, password and mobile number are required.");

  if (!isFirebaseConfigured()) {
    return {
      uid: `local-${Date.now()}`,
      name,
      email,
      mobile,
    };
  }

  const credential = await createUserWithEmailAndPassword(
    auth,
    email,
    password,
  );

  await updateProfile(credential.user, {
    displayName: name,
  });

  await setDoc(
    doc(db, collections.users, credential.user.uid),
    {
      name,
      email,
      mobile,
      createdAt: serverTimestamp(),
    },
    {
      merge: true,
    },
  );

  return {
    uid: credential.user.uid,
    name,
    email,
    mobile,
  };
}
export async function loginUser({ email, password }) {
  if (!isFirebaseConfigured())
    return { uid: "local-user", name: "Rahul", email, mobile: "" };
  const credential = await signInWithEmailAndPassword(auth, email, password);
  return {
    uid: credential.user.uid,
    name: credential.user.displayName || "FreshLoop Customer",
    email: credential.user.email,
    mobile: credential.user.phoneNumber || "",
  };
}
export async function logoutUser() {
  if (isFirebaseConfigured()) await signOut(auth);
}

export async function updateUserProfile({ name, mobile }) {
  if (!isFirebaseConfigured()) {
    return { name, mobile };
  }

  if (!auth?.currentUser) throw new Error("Please login first.");

  await updateProfile(auth.currentUser, { displayName: name });
  await setDoc(
    doc(db, collections.users, auth.currentUser.uid),
    { name, mobile, email: auth.currentUser.email || "" },
    { merge: true },
  );

  return {
    uid: auth.currentUser.uid,
    name,
    email: auth.currentUser.email || "",
    mobile,
  };
}
